import React, { useCallback, useContext, useMemo } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";
import { NEWS_LIST_SORT } from "src/stores/NewsListStore";
import { TagSearch } from "src/components/tagSearch/TagSearch";
import styles from "./NewsOverviewToolbar.module.css";

// Search with the tags "Meine Liegenschaften" and "Nur Meine", and the sorting, like on the page "Tickets".
const NewsOverviewToolbarBase = () => {
    const { t } = useTranslation();
    const { uiStore, newsListStore } = useContext(RootStoreContext);
    const { filter, searchTags, setFilter, setSearchTag, clearFilter } = newsListStore;

    const onChangeSearchQuery = useCallback((query: string) => setFilter({ query }), [setFilter]);

    const onSortChange = useCallback((sort: NEWS_LIST_SORT) => setFilter({ sort }), [setFilter]);

    const sortItems = useMemo(
        () => [
            { label: t(`screens.news.sort.${NEWS_LIST_SORT.NEWEST}`), value: NEWS_LIST_SORT.NEWEST },
            { label: t(`screens.news.sort.${NEWS_LIST_SORT.OLDEST}`), value: NEWS_LIST_SORT.OLDEST }
        ],
        [t]
    );

    return (
        <div className={`${styles.Toolbar} mb-3`}>
            <div className={styles.ToolbarTagSearch}>
                <TagSearch
                    searchTags={searchTags}
                    value={filter.query}
                    updateTagStatusById={setSearchTag}
                    onChangeInput={onChangeSearchQuery}
                    reset={clearFilter}
                />
            </div>
            <div className={styles.ToolbarSort}>
                <UI.Dropdown
                    id="sort"
                    onSelect={onSortChange}
                    items={sortItems}
                    label={uiStore.isMobile ? "" : t(`screens.news.sort.${filter.sort}`)}
                    icon={uiStore.isMobile && <UI.Icon icon={UI.SVGIcon.Sort} />}
                />
            </div>
        </div>
    );
};

export const NewsOverviewToolbar = observer(NewsOverviewToolbarBase);
